/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InventoryStockTakeDto as DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto } from '../../models/Digiwork/MaitreD/Pos/DTO/InventoryStockTake/inventory-stock-take-dto';

export interface CancelInventoryStockTake$Params {
  inventoryId: string;
  stockTakeId: string;
}

export function cancelInventoryStockTake(http: HttpClient, rootUrl: string, params: CancelInventoryStockTake$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto>> {
  const rb = new RequestBuilder(rootUrl, cancelInventoryStockTake.PATH, 'put');
  if (params) {
    rb.path('inventoryId', params.inventoryId, {});
    rb.path('stockTakeId', params.stockTakeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakeDto>;
    })
  );
}

cancelInventoryStockTake.PATH = '/api/inventories/{inventoryId}/stock-takes/{stockTakeId}/cancel';
